import type { AxiosPromise } from "axios";
import { apiClient } from "@/api/modules/base.ts";
import { Route } from "@/api/modules/autoQ/userSettings/route.ts";

export const setDefaultMailSender = (mailSenderId: number): AxiosPromise<void> => apiClient.post(Route.SetDefaultMailSender, { mailSenderId });